module.exports = __webpack_public_path__ + "img/8.80821188.jpg";